import React from 'react';
import styled from 'styled-components';
import tw from 'twin.macro';
import { StepProps } from '../../types';

const Container = styled.div`
  ${tw`flex flex-col h-full`}
`;

const SectionLabel = styled.div`
  ${tw`text-xs font-semibold text-text-secondary uppercase tracking-wider mb-3`}
`;

const Title = styled.h2`
  ${tw`text-xl font-semibold text-text-primary mb-2`}
`;

const Subtitle = styled.p`
  ${tw`text-sm text-text-secondary mb-6`}
`;

const InputGroup = styled.div`
  ${tw`mb-4`}
`;

const Label = styled.label`
  ${tw`block text-sm font-medium text-text-secondary mb-2`}
`;

const Input = styled.input`
  ${tw`w-full p-3 border border-border-default rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent`}
`;

const ContinueButton = styled.button`
  ${tw`w-full py-4 font-semibold rounded-card mt-auto bg-black text-white hover:bg-black-hover`}
`;

const RepairShopInfoStep: React.FC<StepProps> = ({ formData, updateFormData, onNext }) => {
  const shopInfo = formData.repairShopInfo || {};

  const handleChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    updateFormData({
      repairShopInfo: {
        ...shopInfo,
        [field]: e.target.value,
      },
    });
  };

  return (
    <Container>
      <SectionLabel>REPAIR INFORMATION</SectionLabel>
      <Title>Where will you take the vehicle to be repaired?</Title>
      <Subtitle>
        If the vehicle is repairable, please let us know the repair shop details (optional).
      </Subtitle>

      <InputGroup>
        <Label>Repair shop name</Label>
        <Input
          type="text"
          placeholder="Shop name"
          value={shopInfo.shopName || ''}
          onChange={handleChange('shopName')}
        />
      </InputGroup>

      <InputGroup>
        <Label>Address</Label>
        <Input
          type="text"
          placeholder="123 Repair Street, City, State"
          value={shopInfo.address || ''}
          onChange={handleChange('address')}
        />
      </InputGroup>

      <InputGroup>
        <Label>Contact person name</Label>
        <Input
          type="text"
          placeholder="Contact name"
          value={shopInfo.contactName || ''}
          onChange={handleChange('contactName')}
        />
      </InputGroup>

      <InputGroup>
        <Label>Phone number</Label>
        <Input
          type="tel"
          placeholder="(555) 123-4567"
          value={shopInfo.phoneNumber || ''}
          onChange={handleChange('phoneNumber')}
        />
      </InputGroup>

      <ContinueButton onClick={onNext}>Continue</ContinueButton>
    </Container>
  );
};

export default RepairShopInfoStep;
